import { GACodes } from '@/src/listings/components/_shared/constants';
import styles from './TravelModeLink.module.scss';
import { trackAnalyticsEvent } from '@eventbrite/legacy-infra.site-analytics';
interface Props {
  ariaLabel: string;
  queryParams: Record<string, string>;
  label: string;
  heapId: string;
  location: { latitude: number; longitude: number };
  children: React.ReactNode;
}

export const TravelModeLink: React.FC<Props> = ({ ariaLabel, queryParams, label, heapId, location, children }) => {
  const extraParams = new URLSearchParams(queryParams).toString();
  const G_MAPS_LINK = 'https://maps.google.com?saddr=Current+Location';
  const link = `${G_MAPS_LINK}&daddr=${location.latitude},${location.longitude}&${extraParams}`;
  return (
    <a
      className={styles.link}
      href={link}
      target="_blank"
      rel="noreferrer"
      aria-label={ariaLabel}
      data-heap-id={heapId}
      onClick={() => {
        trackAnalyticsEvent({
          category: GACodes.GA_CATEGORY_LISTING,
          action: GACodes.GA_ACTION_DIRECTIONS,
          label: label,
        });
      }}
    >
      {children}
    </a>
  );
};
